import { forwardRef } from 'react'

import { T } from '@tribeplatform/react-components/i18n'
import { cn } from '@tribeplatform/react-components/utils/cn'
import { useRouter, useRouterPath } from '@tribeplatform/react-sdk'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useRouteModeAnchor } from '../useRouteModeAnchor.js'

import { AnchorComponentProps } from './index.js'

const ModerationLink = forwardRef<HTMLAnchorElement, AnchorComponentProps>(
  (props, ref) => {
    const { Link } = useRouter()
    return <Link ref={ref} href="/settings/moderation" {...props} />
  },
)
ModerationLink.displayName = 'ModerationLink'

export function ModerationModeDropDownItem() {
  const anchor = useRouteModeAnchor()
  const Comp = anchor.moderation ?? ModerationLink
  return (
    <Dropdown.Item as={Comp} leadingIcon={<SvgIcon name="moderation" />}>
      <T id="Generics.Moderation" defaultMessage="Moderation" />
    </Dropdown.Item>
  )
}

export function ModerationModeSheetItem() {
  const pathname = useRouterPath()
  const anchor = useRouteModeAnchor()
  const Comp = anchor.moderation ?? ModerationLink
  const isActive = pathname.startsWith('/settings/moderation')
  return (
    <Comp
      className={cn('flex items-center gap-2 p-3', {
        'bg-surface pointer-events-none': isActive,
      })}
    >
      <SvgIcon name="moderation" />
      <T id="Generics.Moderation" defaultMessage="Moderation" />
    </Comp>
  )
}
